import { loadScoring, setScoringTask } from '../../scoringGen7';
import { FORM_FIELDS } from '../../../constants';
import { formDataToArrangeOkb } from '../../../store/adapters/formStore';

type TScoreData = { score?: number | null; isHit?: boolean | null };

const scoringCache: { [key: string]: TScoreData } = {};

export const getScoring = async (formData: FE.FormData, userId?: string): Promise<TScoreData> => {
    const cacheKey = JSON.stringify({ ...formDataToArrangeOkb(formData), userId });
    const cachedResult = scoringCache[cacheKey];

    if (cachedResult) {
        return cachedResult;
    }

    const taskResult = await setScoringTask(formData, userId);

    const { value, taskId } = taskResult || {};

    const scoringResult = value !== null || !taskId ? taskResult : await loadScoring(taskId);

    const { value: score, isHit } = scoringResult || {};

    const result = { score, isHit };

    if (score !== null) {
        Object.keys(scoringCache).forEach((key) => delete scoringCache[key]);
        scoringCache[cacheKey] = result;
    }

    return result;
};

export const scoringToFormData = ({ score, isHit }: TScoreData): FE.FormData => {
    return {
        [FORM_FIELDS.SCORE_GEN7_CL]: score,
        [FORM_FIELDS.SCORE_GEN7_CL_HIT]: isHit,
    };
};
